import { render } from "./ProjectItem.vue?vue&type=template&id=f71aa38e&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"

import "./ProjectItem.vue?vue&type=style&index=0&id=f71aa38e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f71aa38e"]])

export default __exports__